import { useQuery, gql } from '@apollo/client';
import dateFormat from "dateformat";
import { useParams } from "react-router-dom";

const FIND_POST = gql`
    query findPostBySlug($slugToSearch: String!) {
        posts(where: {slug: $slugToSearch}) {
            id
            title
            date
            slug
            tags
            contentPreview
            content{
                html
            }
            author {
                name
                avatar {
                url
                }
            }
            coverPhoto {
                url
            }
        }
    }
`

export default function BlogComp() {

    
const currentEntry = useParams().postSlug
console.log(currentEntry)


    const { loading, error, data } = useQuery(FIND_POST, {
        variables: {
            slugToSearch: currentEntry
        },
    });

    if (error) return <main className="blog-landing"><h1>Error : {error.message}</h1></main>;
    if (loading) return <main className="blog-landing"><h1>Loading...</h1></main>
    const post = data?.posts
    //     // const [post, setPost] = useState(() => data.post);
    console.log(post)

    if (data) return (
        <main className="blog-landing-post">            
            {post.map((post) => (
                    <>
                    <img src={`${post.coverPhoto.url}`} className="blog-image" alt=""/>
                    <h1>{post.title}</h1>
                    <div className="blog-subheader">
                    <div className="blog-author-details"><img src={`${post.author.avatar.url}`} className="blog-author-img"/><p className="blog-author">{post.author.name}</p> <p className="blog-date">{dateFormat(post.date, "dd mmm yyyy")}</p></div>
                    <p className="blog-tags"> {post.tags.map((tag) => 
                        <span className="tag"> {tag} </span>)}</p>
                    </div>
                    <div className="blog-content" dangerouslySetInnerHTML={{__html: post.content.html}}></div>
                    </>
                ))}
        </main>
    )
}